import { render, staticRenderFns } from "./ModalModulosInscritos.vue?vue&type=template&id=3e38c93f"
import script from "./ModalModulosInscritos.vue?vue&type=script&lang=js"
export * from "./ModalModulosInscritos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports